import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { buildDirectoryLabel } from '@components/Checkout/steps/PhoneNumberStep/utils/phoneNumberStepUtils';
import type { DirectoryListingProps } from '@components/Checkout/steps/PhoneNumberStep/PhoneNumberStep.types';
import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';

const HEADING = 'Directory Assistance (DA, 411) / Directory Listing (DL, phone book)';

export const DirectoryListing = ({ value, options, headingVariant, onChange }: DirectoryListingProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange((e.target as HTMLInputElement).value);
  };

  const radioOptions = options.map((dl) => ({
    value: dl.name,
    label: buildDirectoryLabel(dl.name),
  }));

  return (
    <Stack gap="10px">
      <Typography variant={headingVariant} sx={{ lineHeight: '150%' }}>
        {HEADING}
      </Typography>
      <RadioGroupSet value={value} onChange={handleChange} options={radioOptions} />
    </Stack>
  );
};
